<button #openProductSearchButton class="searchButton" mat-stroked-button data-test="product" (click)="handleClick()">
  <mat-icon>search</mat-icon>
  <span>{{ 'product.search.button' | translate }}</span>
</button>
